import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import {
  getOrdersAction,
  updateAllOrderStatusActions,
  updateOrderStatusActions,
} from '../orders/actions';
import {
  makeSelectOrdersList,
  makeSelectCountList,
  makeSelectLoading,
} from '../orders/selectors';
import { createStructuredSelector } from 'reselect';
import Pagination from '@material-ui/lab/Pagination';
import RenderFilter from '../../utils/listDaynamicFilterHookForm';
import List from './components/list';
import { useForm } from 'react-hook-form';
import theme from '../../theme';
import { rulesOrderStatus } from '../../utils/rulesOrderStatus';
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';
import {
  Typography,
  CircularProgress,
  Button,
  Grid,
  TextField,
  IconButton,
  FormControl,
  Select,
  MenuItem,
} from '@material-ui/core';
// Icon
import Icon from '@mdi/react';
import {
  mdiAccountOutline,
  mdiPackageVariantClosed,
  mdiCalendar,
  mdiPencilOutline,
  mdiPackageVariant,
  mdiBarcodeScan,
  mdiCashMultiple,
  mdiStoreOutline,
  mdiPlusBoxOutline,
} from '@mdi/js';
import useQuery from '../../utils/hook/useQuery';

// Helper
import {
  checkMatchMedia,
  removeEmptyValueObject,
} from '../../utils/helpers';

import EXCEL from './excel';

// Style
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {},
    paper: {},
    loading: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      height: '50vh',
      alignSelf: 'center',
      justifyContent: 'center',
      background: '#ccc',
    },
    pagination: {
      // marginTop: theme.spacing(1),
    },
    textArea: {
      width: '100%',
    },
    searchBox: {
      display: 'flex',
      position: 'relative',
      backgroundColor: theme.palette.common.white,
      borderRadius: '4px',
      boxShadow: '0px 2px 4px 1px rgba(0,0,0,0.1)',
    },
    subtitle: {
      fontSize: '14px',
      fontWeight: 500,
      color: '#8A8A8A',
    },

    '& .MuiInput-underline::before': {
      borderBottom: '1px solid #d8d8d8 !important',
    },
    detail: {
      backgroundColor: 'white',
      padding: '5px',
      width: '100%',
    },
    editIcon: {
      textAlign: 'center',
      position: 'relative',
      paddingLeft: theme.spacing(8),
      marginBottom: theme.spacing(7),
      '&::before': {
        content: '""',
        position: 'absolute',
        width: '100px',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%,-50%)',
        height: '100px',
        borderRadius: '50%',
        opacity: '0.2',
        backgroundColor: theme.palette.blue.main,
      },
    },
    cancelTitle: {
      fontSize: '16px',
      fontWeight: 500,
      textAlign: 'center',
      marginBottom: theme.spacing(3),
    },
    actionsBox: {
      paddingTop: theme.spacing(2),
      paddingRight: theme.spacing(3),
      paddingLeft: theme.spacing(3),
    },
    cancelIcon: {
      textAlign: 'center',
      position: 'relative',
      paddingLeft: theme.spacing(8),
      marginBottom: theme.spacing(7),
      '&::before': {
        content: '""',
        position: 'absolute',
        width: '100px',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%,-50%)',
        height: '100px',
        borderRadius: '50%',
        opacity: '0.2',
        backgroundColor: theme.palette.error.main,
      },
    },
    textInput: {
      // width: '25ch',
      '& input, .MuiSelect-root': {
        padding: '12px 10px 12px !important',
      },

      '& .MuiInput-underline::before': {
        borderBottom: '1px solid #d8d8d8 !important',
      },
    },
  })
);

const DepoOrders = (props: any) => {
  const classes = useStyles();
  const { register, handleSubmit, setValue, getValues } = useForm({
    defaultValues: {
      trackingCode: '',
      idCode: '',
    },
  });
  const { filtersValues, setFiltersValues } = useQuery({
    page: 0,
    size: 100,
    'status.equals': 'ORDERED',
    'orderType.equals': 'FROM_CENTER',
  } as any);
  const [filters, setFilters] = useState([]);
  const [id, setId] = useState(-1 as number);
  const [selected, setSelected] = React.useState<string[]>([]);
  const [openSize, setOpenSize] = React.useState(false as boolean);

  const changeOrderStatusSubmit = (data: any) => {
    props.updateOrderStatusDispatch({
      id: data.idCode,
      body: { status: 'SCANNED', description: '' },
      pagination: filtersValues,
    });
  };

  const receiptConfirmation = () => {
    props.updateAllOrderStatusDispatch({
      ids: selected,
      status: 'SCANNED',
      description: '',
      pagination: filtersValues,
    });
  };
  const getOrders = () => {
    const { page, size } = filtersValues;
    props.ordersDispatch({
      ...filtersValues,
      page,
      size,
    });
  };
  const selectItem = (id: string, status?: string) => {
    const selectedIndex = selected.indexOf(id);
    if (selectedIndex > -1) {
      setSelected(selected.filter(el => el != id));
    } else {
      setSelected([...selected, id]);
    }
  };
  const handleSelectAllClick = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.checked) {
      const newSelecteds = props.ordersList.map((n: any) => n.id);
      setSelected(newSelecteds);
      return;
    }
    setSelected([]);
  };
  const removeFilterHandler = (fieldName: any) => {
    const filtered = { ...filtersValues };
    delete filtered[fieldName];
    setFiltersValues(filtered);
  };

  const filterTranslator = (fieldName: string) => {
    const status = {
      customerName: 'نام سفارش دهنده',
      'customerName.equals': 'نام سفارش دهنده:',
      'customerName.contais': 'نام سفارش دهنده:',
      trackingCode: 'کد پیگیری',
      'trackingCode.equals': 'کد پیگیری',
      'trackingCode.contains': 'کد پیگیری',
      'id.equals': 'شناسه سفارش:',
      'id.contains': 'شناسه سفارش:',
      deliveryDate: 'زمان تحویل',
      'deliveryDate.equals': 'زمان تحویل:',
      'deliveryDate.contains': 'زمان تحویل:',
      status: 'وضعیت سفارش',
      'status.in': 'وضعیت سفارش:',
      'status.notIn': 'وضعیت سفارش:',
    };
    return status[fieldName];
  };
  const handleChangePage = (
    event: React.ChangeEvent<unknown>,
    page: number
  ) => {
    setFiltersValues({ ...filtersValues, page: page - 1 });
  };
  const handleClose = () => {
    setOpenSize(false);
  };

  const handleChangeSizePage = (event: React.ChangeEvent<{ value: unknown }>) => {
    setFiltersValues({ ...filtersValues, page: 0, size: event.target.value });
  };
  useEffect(() => {
    getOrders();
    setupFilters();
    const storedId = JSON.parse(localStorage.getItem('id'));
    setId(storedId);
  }, [filtersValues]);

  useEffect(() => {
    const storedId = JSON.parse(localStorage.getItem('id'));
    if (storedId) {
      localStorage.removeItem('id');
    }
    localStorage.setItem('id', JSON.stringify(selected));
  }, [id]);

  const setupFilters = () => {
    setFilters([
      {
        type: 'input',
        id: 'customerName.contains',
        label: 'نام گیرنده',
        icon: mdiAccountOutline,
      },
      {
        type: 'input',
        id: 'Id.equals',
        label: 'شناسه سفارش',
        icon: mdiCashMultiple,
      },
      {
        type: 'input',
        id: 'orderTrackingCode.equals',
        label: 'نام شرکت',
        icon: mdiStoreOutline,
      },
      {
        type: 'checkbox',
        id: 'status.in',
        label: 'وضعیت سفارش',
        data: [
          'ORDERED',
          'DELIVERED_TO_POST',
          'DELIVERED_TO_CENTER',
          'SUPPLIED_IN_CENTER',
          'PACKAGED',
          'BUNDLED',
          'LOADED',
          'ARRIVED',
          'DELIVERED',
          'NOT_DELIVERED',
          'RETURNED',
          'SUPPLYING',
          'CANCELLED',
        ],
        translateType: 'Order',
        icon: mdiPackageVariantClosed,
      },
      {
        type: 'date-picker',
        id: 'deliveryDate.greaterThanOrEqual',
        label: 'تاریخ تحویل از ',
        icon: mdiCalendar,
      },
      {
        type: 'date-picker',
        id: 'deliveryDate.lessThanOrEqual',
        label: '  تا تاریخ تحویل ',
        icon: mdiCalendar,
      },
    ]);
  };
  let headCells = [];

  headCells = [
    {
      id: 'customerAddress',
      label: 'آدرس',
      type: 'input',
    },
    {
      id: 'customerName',
      label: 'نام گیرنده',
      type: 'input',
    },
    {
      id: 'id',
      label: 'شناسه سفارش',
      type: 'input',
    },
    {
      id: 'trackingCode',
      label: 'کدپیگیری',
      type: 'input',
    },
    {
      id: 'partnerName',
      label: 'نام شرکت',
      type: 'input',
    },
    {
      id: 'deliveryDate',
      label: 'تاریخ و بازه تحویل',
      type: 'date-picker',
    },
    {
      id: 'status',
      label: 'وضعیت سفارش',
      translate: 'Order',
      checkbox: true,
      type: 'checkbox',
      data: [
        'ORDERED',
        'DELIVERED_TO_POST',
        'DELIVERED_TO_CENTER',
        'SUPPLIED_IN_CENTER',
        'PACKAGED',
        'BUNDLED',
        'LOADED',
        'ARRIVED',
        'DELIVERED',
        'NOT_DELIVERED',
        'RETURNED',
        'CANCELLED',
        'REGISTERED_IN_3PL',
        'REGISTERING_IN_3PL',
        'DELIVERED_TO_COURIER',
        'DELIVERED_TO_3PL_COURIER',
      ],
      translateType: 'Order',
      statusModel: rulesOrderStatus,
      selectIcon: mdiPencilOutline,
      statusType: 'Order',
    },
  ];
  const head = { headCells };
  return (
    <div>
      <Grid container spacing={6}>
        <Grid container item xs={12} sm={6} alignItems="center">
          <Typography variant="h6" component="div">
            {`دریافت سفارش`}
          </Typography>
        </Grid>
        <Grid item xs={12} sm={6}>
          <RenderFilter
            filters={filters}
            onFilter={(filtervalues: any) => {
              setFiltersValues({
                ...removeEmptyValueObject(filtervalues),
                'orderType.equals': 'FROM_CENTER',
                page: 0,
                size: 100,
              });
            }}
            mainFiltersCount={1}
            baseFilter={{
              type: 'input',
              id: 'id.equals',
              placeholder: 'شناسه سفارش',
            }}
            filterValues={filtersValues}
          />
        </Grid>
        <Grid container item xs={12} direction="row-reverse">
          <Button
            variant="contained"
            color="secondary"
            onClick={() => receiptConfirmation()}
            // onClick={() => props.history.push('/create-bundle')}
            // startIcon={<Icon path={mdiPlus} size={1} />}
            disabled={selected.length == 0}
            size={'large'}
          >{`تایید دریافت`}</Button>
          {/* <CSV
                        getData={props.allBundlesDispatch}
                        data={props.allBundlesList}
                        filtersValues={filtersValues}
                        loading={props.loading}
                    />
                    <ExelExport
                        data={props.allBundlesList}
                        loading={props.loading}
                        filtersValues={filtersValues}
                        handleRequest={props.allBundlesDispatch}
                    /> */}




          <Button
            variant="contained"
            color="primary"
            style={{ marginLeft: '8px' }}
            onClick={() =>
              props.history.push('/create-grouping-order')
            }
            startIcon={
              <Icon path={mdiPlusBoxOutline} size={1} />
            }
            size={
              checkMatchMedia('(max-width: 1024px)')
                ? 'small'
                : 'large'
            }
          >{`ایجاد گروهی سفارش`}</Button>

        </Grid>
      </Grid>
      <Grid container item xs={12} direction="row" justify='space-between'>
        <form
          style={{ width: '550px', marginBottom: '40px' }}
          onSubmit={handleSubmit(changeOrderStatusSubmit)}
        >
          <Grid
            className={classes.detail}
            container
            spacing={2}
            alignItems="center"
          >
            <Grid item xs={10} alignItems="center">
              <span style={{ margin: '0 10px' }}>
                <Icon path={mdiBarcodeScan} size={1} color="black" />
              </span>
              <span>
                <TextField
                  fullWidth
                  id="idCode"
                  name="idCode"
                  inputRef={register({
                    // required: true,
                  })}
                  autoFocus
                  label="شناسه سفارش را وارد کنید"
                />
              </span>
            </Grid>
            <Grid item xs={2}>
              <IconButton
                aria-label="details"
                type="submit"
                size="small"
                title="دریافت بسته"
                data-cy="details"
              >
                <Icon
                  path={mdiPackageVariant}
                  size={1}
                  color={theme.palette.info.main}
                />
              </IconButton>
            </Grid>
          </Grid>
        </form>
        <Grid style={{ marginTop: 'auto', marginBottom: '32px' }}>

          <EXCEL
            ordersDispatch={props.ordersDispatch}
            data={props.ordersList}
            filtersValues={filtersValues}
            loading={props.loading}
          />
        </Grid>
      </Grid>
      <Grid container spacing={3}>
        <Grid item xs={12}>
          {props.loading ? (
            <div className={classes.loading}>
              <CircularProgress />
            </div>
          ) : (
            <>
              <List
                loading={props.loading}
                data={props.ordersList}
                handleSelect={(id: number, status: string) => {
                  selectItem(id, status);
                  setId(id);
                }}
                selectedItems={selected}
                selectAll={handleSelectAllClick}
                head={head}
                filterVal={filtersValues}
                onFilterValue={(filtervalues: any) => {
                  setFiltersValues({
                    ...removeEmptyValueObject(filtervalues),
                    ...filtersValues,
                    page: 0,
                    size: 10,
                  });
                }}
                removeFilterHandler={removeFilterHandler}
                filterLabelTranslator={filterTranslator}
              />
            </>
          )}
        </Grid>
        <Grid item xs={12} sm={6}>
          <FormControl
            style={{
              display: 'flex',
              flexDirection: 'row',
              alignItems: 'center',
            }}
          >
            <div style={{ marginLeft: '10px', color: '#8a8a8a' }}>
              {' '}
              تعداد نمایش در هر صفحه:
            </div>
            <Select
              open={openSize}
              onClose={handleClose}
              onOpen={() => setOpenSize(true)}
              value={filtersValues.size}
              onChange={handleChangeSizePage}
            >
              <MenuItem value={10}>10</MenuItem>
              <MenuItem value={20}>20</MenuItem>
              <MenuItem value={50}>50</MenuItem>
              <MenuItem value={100}>100</MenuItem>
            </Select>
          </FormControl>
        </Grid>
        <Grid xs={12} sm={6} container item direction="row-reverse">
          <Pagination
            className={classes.pagination}
            count={Math.ceil(props.count / filtersValues.size)}
            color="secondary"
            page={filtersValues.page + 1}
            onChange={handleChangePage}
          />
        </Grid>
      </Grid>
    </div>
  );
};

const mapStateToProps = createStructuredSelector<Store, SelectorProps>({
  ordersList: makeSelectOrdersList(),
  count: makeSelectCountList(),
  loading: makeSelectLoading(),
});

function mapDispatchToProps(dispatch: Function) {
  return {
    ordersDispatch: (payload: any) => dispatch(getOrdersAction(payload)),
    updateAllOrderStatusDispatch: (payload: PayloadAllUpdate) =>
      dispatch(updateAllOrderStatusActions(payload)),
    updateOrderStatusDispatch: (payload: {
      id: number;
      body: string;
      pagination: object;
    }) => dispatch(updateOrderStatusActions(payload)),
  };
}

const widthConnect = connect(mapStateToProps, mapDispatchToProps);
export default compose(widthConnect)(DepoOrders);
